var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import classnames from 'classnames';
import { Tooltip } from '../../../Tooltip';
import { CellWithGridDropdown } from '../../components/DataGridCellWithDropdown/component/CellWithGridDropdown';
import { getCellValue } from '../../utils';
import { CurrencyFormatter } from './CurrencyFormatter';
import { ChangeCellFormatter } from './ChangeFormatter';
import { useColumnAndCellSelection } from './hooks';
const DefaultValueDisplay = ({ value }) => React.createElement("span", null, getCellValue(value));
const CellBaseFormatter = (_a) => {
    var { value, children } = _a, props = __rest(_a, ["value", "children"]);
    const { selectFullColumn, onSelection } = useColumnAndCellSelection(Object.assign({ value }, props));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames('grid-table-base cell', {
                'cell-selected': selectFullColumn,
            }), onClick: onSelection }, children)));
};
const CellBaseFormatterWithValue = (_a) => {
    var { value } = _a, props = __rest(_a, ["value"]);
    const cellValue = React.createElement(DefaultValueDisplay, { value: value });
    return (React.createElement(CellBaseFormatter, Object.assign({ value: value }, props),
        React.createElement(Tooltip, { className: "data-grid_tooltip", tip: getCellValue(value), forEllipsesText: true }, cellValue)));
};
export const GridDropdownCellFomatter = (props) => (React.createElement(CellBaseFormatter, Object.assign({}, props),
    React.createElement(CellWithGridDropdown, Object.assign({}, props, { fullWidth: true }),
        React.createElement(DefaultValueDisplay, Object.assign({}, props)))));
const BaseCellFormatter = (props) => {
    const { column } = props;
    switch (column.columnType) {
        case 'change':
            return React.createElement(ChangeCellFormatter, Object.assign({}, props));
        case 'currency':
            return React.createElement(CurrencyFormatter, Object.assign({}, props));
        case 'grid_dropdown':
            return React.createElement(GridDropdownCellFomatter, Object.assign({}, props));
        default:
            return React.createElement(CellBaseFormatterWithValue, Object.assign({}, props));
    }
};
export const CellFormatterFactory = (props) => (React.createElement(DataTypeProvider, Object.assign({ formatterComponent: (customProps) => (React.createElement(BaseCellFormatter, Object.assign({}, Object.assign(Object.assign({}, props), customProps)))) }, props)));
//# sourceMappingURL=CellFormatterFactory.js.map